import { Box, Button, Typography,  Dialog,  DialogContent, DialogActions, DialogTitle, IconButton, Stack, Avatar } from '@mui/material';
import { ReportsBuilderContext, ReportBuilderValues } from '../context/ReportsBuilderContext';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Save01 } from '../../../assets';
import { theme } from '../../../theme';

const Informations=() => {
  const { t,
    openInformationDialog,
    informationModalTitle,
    informationMessage,
    handleClose, 
    isError,
    handleUpdateReportConfirmed,
    isDuplicated,
    navigateToReports,
  } = useContext(ReportsBuilderContext) as ReportBuilderValues;

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={openInformationDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            sx={{
              backgroundColor: () => theme.palette.primary[100],
              color: () => theme.palette.primary[700],
            }}
          >
            <Save01 color={theme.palette.primary[500]} />
          </Avatar>
        </Box> 
        <IconButton
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}> {t(informationModalTitle)}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 , whiteSpace: 'pre-line' }}
            variant="textSM">
            {t(informationMessage)}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ 
        padding: '0px 24px 24px', 
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px', 
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          {isDuplicated ? (
            <Button
              fullWidth
              variant="secondary"
              size="md"
              onClick={navigateToReports}
            >
              {t('closeModal')}
            </Button>
          ) : (
            <>
              <Button
                fullWidth
                variant="secondary"
                size="md"
                sx={{ fontSize: '16px' }} 
                onClick={handleClose}
              >
                {t('close')}
              </Button>
              {!isError && (
                <Button
                  fullWidth
                  variant="primary"
                  size="md"
                  sx={{ fontSize: '16px' }} 
                  onClick={handleUpdateReportConfirmed}
                >
                  {t('confirm')}
                </Button>
              )}
            </>
          )}

      
        </Stack>
      </DialogActions>
    </Dialog >
  );
};

export default Informations;